var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 16H22.8571H21.1429H16.8571H15.1429H10.8571H9.14286H8.85714C8.38571 16 8 16.3937 8 16.875V22.7083C8 22.8687 8.12857 23 8.28571 23H10.2857C10.4143 23 10.5257 22.9125 10.56 22.7871L11.0714 20.9583H20.9286L21.44 22.7871C21.4743 22.9125 21.5857 23 21.7143 23H23.7143C23.8714 23 24 22.8687 24 22.7083V16.875C24 16.3937 23.6143 16 23.1429 16Z",
    fill: "#D8D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16V14.8003C10.75 14.3054 11.1437 13.9005 11.625 13.9005H14.25C14.7312 13.9005 15.125 14.3054 15.125 14.8003V16H16.875V14.8003C16.875 14.3054 17.2688 13.9005 17.75 13.9005H20.375C20.8562 13.9005 21.25 14.3054 21.25 14.8003V16H22.4167H23V10.3014C23 10.1365 22.8687 10.0015 22.7083 10.0015H20.6667C20.515 10.0015 20.3896 10.1215 20.375 10.2774L20.3196 10.9673C17.8054 9.67758 14.1946 9.67758 11.6804 10.9673L11.625 10.2774C11.6104 10.1215 11.485 10.0015 11.3333 10.0015H9.29167C9.13125 10.0015 9 10.1365 9 10.3014V16H9.58333H10.75Z",
    fill: "#D8D1CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD1);
export default __webpack_public_path__ + "static/media/d1.f3e5fd7949078466e7ca998aa96461e4.svg";
export { ForwardRef as ReactComponent };